webpackJsonp([72138227098318],{

/***/ 938:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/feature-1.17e345b8.png";

/***/ }),

/***/ 939:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/feature-2.193c3b45.png";

/***/ }),

/***/ 940:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/feature-3.7b5edca4.png";

/***/ }),

/***/ 941:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/feature-4.63da34be.png";

/***/ }),

/***/ 942:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/feature-5.68ae533d.png";

/***/ }),

/***/ 943:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hero.07155499.jpg";

/***/ }),

/***/ 944:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/seo-hero.a247730f.png";

/***/ }),

/***/ 303:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _reactHelmet = __webpack_require__(20);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Section = __webpack_require__(13);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _Button = __webpack_require__(12);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _SectionTwoCol = __webpack_require__(85);
	
	var _twoCol = __webpack_require__(21);
	
	var _SectionHeader = __webpack_require__(27);
	
	var _SectionHeader2 = _interopRequireDefault(_SectionHeader);
	
	var _SectionPreHeader = __webpack_require__(28);
	
	var _SectionPreHeader2 = _interopRequireDefault(_SectionPreHeader);
	
	var _SubHeader = __webpack_require__(18);
	
	var _SubHeader2 = _interopRequireDefault(_SubHeader);
	
	var _CalloutContainer = __webpack_require__(26);
	
	var _CalloutContainer2 = _interopRequireDefault(_CalloutContainer);
	
	var _HubspotFormSection = __webpack_require__(51);
	
	var _HubspotFormSection2 = _interopRequireDefault(_HubspotFormSection);
	
	var _hero = __webpack_require__(943);
	
	var _hero2 = _interopRequireDefault(_hero);
	
	var _feature = __webpack_require__(938);
	
	var _feature2 = _interopRequireDefault(_feature);
	
	var _feature3 = __webpack_require__(939);
	
	var _feature4 = _interopRequireDefault(_feature3);
	
	var _feature5 = __webpack_require__(940);
	
	var _feature6 = _interopRequireDefault(_feature5);
	
	var _feature7 = __webpack_require__(941);
	
	var _feature8 = _interopRequireDefault(_feature7);
	
	var _feature9 = __webpack_require__(942);
	
	var _feature10 = _interopRequireDefault(_feature9);
	
	var _seoHero = __webpack_require__(944);
	
	var _seoHero2 = _interopRequireDefault(_seoHero);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FeaturesPage = function (_React$Component) {
	  _inherits(FeaturesPage, _React$Component);
	
	  function FeaturesPage(props) {
	    _classCallCheck(this, FeaturesPage);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  FeaturesPage.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_reactHelmet2.default, {
	        title: 'Powerful Features',
	        meta: [{ name: 'og:title', content: 'Powerful Features' }, { name: 'description', content: 'Designed to elevate the guest experience, drive more revenue, and increase ratings.' }, { name: 'og:description', content: 'Designed to elevate the guest experience, drive more revenue, and increase ratings.' }, { name: 'og:image', content: _seoHero2.default }, { name: 'og:type', content: "website" }, { name: 'og:locale', content: "en_US" }]
	      }),
	      _react2.default.createElement(
	        _twoCol.TwoCol,
	        { bgColor: '#18aa7a' },
	        _react2.default.createElement(
	          _twoCol.LeftCol,
	          { bgColor: '#18aa7a', skew: true, color: '#fff' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Whistle\'s',
	            _react2.default.createElement('br', null),
	            ' portfolio of',
	            _react2.default.createElement('br', null),
	            ' features'
	          ),
	          _react2.default.createElement(
	            _SubHeader2.default,
	            null,
	            'Our unique features offer more than a messaging tool\u2014',
	            _react2.default.createElement('br', null),
	            ' they offer a way to get ahead in the hospitality industry.'
	          ),
	          _react2.default.createElement(
	            _CalloutContainer2.default,
	            { align: 'left' },
	            _react2.default.createElement(
	              _Button2.default,
	              { secondary: true, to: '/schedule', icon: true },
	              'Book A Demo'
	            )
	          )
	        ),
	        _react2.default.createElement(_twoCol.RightCol, { image: true, bgImgSrc: _hero2.default })
	      ),
	      _react2.default.createElement(
	        _SectionTwoCol.SectionTwoCol,
	        { light: true },
	        _react2.default.createElement(
	          _SectionTwoCol.SectionColumn,
	          { left: true },
	          _react2.default.createElement('img', { src: _feature2.default, alt: 'Chatbot Automation Live Chat' })
	        ),
	        _react2.default.createElement(
	          _SectionTwoCol.SectionColumn,
	          null,
	          _react2.default.createElement(
	            _SectionPreHeader2.default,
	            { align: 'center' },
	            'Chatbot Automation'
	          ),
	          _react2.default.createElement(
	            _SectionHeader2.default,
	            { lower: true, align: 'center' },
	            'Drive more bookings'
	          ),
	          _react2.default.createElement(
	            _SubHeader2.default,
	            { align: 'center' },
	            'With our Chatbot Response feature you\'ll have hundreds of automated responses answering guests questions.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _SectionTwoCol.SectionTwoCol,
	        null,
	        _react2.default.createElement(
	          _SectionTwoCol.SectionColumn,
	          null,
	          _react2.default.createElement(
	            _SectionPreHeader2.default,
	            { align: 'center' },
	            'Team Messaging'
	          ),
	          _react2.default.createElement(
	            _SectionHeader2.default,
	            { lower: true, align: 'center' },
	            'Streamline operations'
	          ),
	          _react2.default.createElement(
	            _SubHeader2.default,
	            { align: 'center' },
	            'Group and team messages to help staff stay on-task while staff training and support ensures everyones success.'
	          )
	        ),
	        _react2.default.createElement(
	          _SectionTwoCol.SectionColumn,
	          { right: true },
	          _react2.default.createElement('img', { src: _feature4.default, alt: 'Team Messaging' })
	        )
	      ),
	      _react2.default.createElement(
	        _SectionTwoCol.SectionTwoCol,
	        { light: true },
	        _react2.default.createElement(
	          _SectionTwoCol.SectionColumn,
	          { left: true },
	          _react2.default.createElement('img', { src: _feature6.default, alt: 'Unlimited Messaging' })
	        ),
	        _react2.default.createElement(
	          _SectionTwoCol.SectionColumn,
	          null,
	          _react2.default.createElement(
	            _SectionPreHeader2.default,
	            { align: 'center' },
	            'Unlimited Messaging'
	          ),
	          _react2.default.createElement(
	            _SectionHeader2.default,
	            { lower: true, align: 'center' },
	            'Answer guests at any time'
	          ),
	          _react2.default.createElement(
	            _SubHeader2.default,
	            { align: 'center' },
	            'There\'s no limit to how many request you can answer with automated responses as well as personalized messages.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _SectionTwoCol.SectionTwoCol,
	        null,
	        _react2.default.createElement(
	          _SectionTwoCol.SectionColumn,
	          null,
	          _react2.default.createElement(
	            _SectionPreHeader2.default,
	            { align: 'center' },
	            'Integrations + Analytics'
	          ),
	          _react2.default.createElement(
	            _SectionHeader2.default,
	            { lower: true, align: 'center' },
	            'All at your fingertips'
	          ),
	          _react2.default.createElement(
	            _SubHeader2.default,
	            { align: 'center' },
	            'Seamlessly integrate your PMS and get real-time, in-app analytics to have tasks as well as insights all-in-one place.'
	          )
	        ),
	        _react2.default.createElement(
	          _SectionTwoCol.SectionColumn,
	          { center: true },
	          _react2.default.createElement('img', { src: _feature8.default, alt: 'PMS Integrations + Analytics' })
	        )
	      ),
	      _react2.default.createElement(
	        _SectionTwoCol.SectionTwoCol,
	        { light: true },
	        _react2.default.createElement(
	          _SectionTwoCol.SectionColumn,
	          { center: true },
	          _react2.default.createElement('img', { src: _feature10.default, alt: 'Voice Intelligence + Guest Surveys' })
	        ),
	        _react2.default.createElement(
	          _SectionTwoCol.SectionColumn,
	          null,
	          _react2.default.createElement(
	            _SectionPreHeader2.default,
	            { align: 'center' },
	            'Voice Intelligence + Guest Surveys'
	          ),
	          _react2.default.createElement(
	            _SectionHeader2.default,
	            { lower: true, align: 'center' },
	            'Communication is key'
	          ),
	          _react2.default.createElement(
	            _SubHeader2.default,
	            { align: 'center' },
	            'With voice-controlled intelligence you can  communicate hands-free with guests. Plus our text messaging surveys gives you real-time feedback before guests depart.'
	          )
	        )
	      ),
	      _react2.default.createElement(_HubspotFormSection2.default, {
	        id: 'book-demo',
	        formId: '7d86c04f-e98e-42eb-ae79-ff2b14c7605a',
	        trackingId: ("AW-844932343/Jf_qCLeXzeYBEPfJ8pID")
	      })
	    );
	  };
	
	  return FeaturesPage;
	}(_react2.default.Component);
	
	exports.default = FeaturesPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-features-js-e04a2ee3574e1193611d.js